var cartPromo = {
    campaigns: [],
    apiWorking: false,

    init: function () {
        if (typeof window.cartPromoCampaigns === 'object') {
            this.campaigns = window.cartPromoCampaigns;
        }
        this.checkCart();
    },

    checkCart: function () {
        fetch('/cart.js', { cache: 'no-store' })
            .then(response => response.json())
            .then(cart => {
                if (cart.total_price > 0) {
                    this.checkPromos(cart);
                } else if (cart.total_price == 0 && cart.item_count > 0) {
                    this.clearCart();
                }
            })
            .catch(error => console.error("Errore nel recupero del carrello:", error));
    },

    checkPromos: function (cart) {
        let cartItems = cart.items;
        let promos = [];
        const currentCampaings = window.cartPromoCampaigns;

        if (currentCampaings?.length === 0) return;

        for (let campaign of currentCampaings) {
            let ret = (campaign.prods.length == 0) ? cartItems : this.matchCampaignInCart(cartItems, cart, campaign);

            // Aggiorna le quantità nel carrello per altre promozioni
            cartItems = ret.cartItems;

            if (ret.promo !== null) {
                promos.push(ret.promo);
            }
        }

        if (promos.length > 0) {
            this.applyPromos(promos);
        }
    },

    resetPromos: function () {
        const currentCampaings = window.cartPromoCampaigns;
        if (currentCampaings.length > 0) {
            let resetArray = currentCampaings.map(campaign => campaign.promo);
            this.applyPromos(resetArray, true);
        }
    },

    applyPromos: function (promos, reset = false) {
        let promosToApply = {};

        if (Array.isArray(promos) && promos.length > 0) {
            for (let promo of promos) {
                for (let p of promo) {
                    let pQty = promosToApply[p.id] || 0,
                        tmpQty = parseInt(document.querySelector(`cart-sample[data-variant-id="${p.id}"]`)?.dataset?.sampleQuantity || '0');
                    promosToApply[p.id] = reset ? 0 : pQty + p.quantity;
                    if(tmpQty > promosToApply[p.id]) promosToApply[p.id] = tmpQty;
                }
            }

            fetch('/cart/update.js', {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ updates: promosToApply }),
            })
                .then(response => response.json())
                .then(cart => {
                    console.log(reset ? "Cart promo resetted!" : "Cart promo updated!");
                    this.updateCartView();
                })
                .catch(error => console.error("Errore nell'aggiornamento delle promo:", error));
        }
    },

    matchCampaignInCart: function (cartItems, cart, campaign) {
        let promo = null;
        let itemsMatch = [];
        let campaignAdjustQuantities = [];
        let cProdFoundCounter = 0;

        for (let cProd of campaign.prods) {
            let cProdFound = false;

            for (let i = 0; i < cartItems.length; i++) {
                let item = cartItems[i];

                if ((cProd.id === item.id || cProd.id === '*') &&
                    cart.total_price >= (campaign.total_price * 100)) {

                    if (item.quantity >= cProd.quantity) {
                        cProdFound = true;
                        campaignAdjustQuantities[i] = item.quantity - cProd.quantity;
                    }
                    cProdFoundCounter += item.quantity;
                }
            }
            itemsMatch.push(cProdFound);
        }

        let promoCondition = (campaign.min_amount == null) ? itemsMatch.indexOf(false) === -1 : campaign.min_amount <= cProdFoundCounter;

        if (promoCondition) {
            for (let i = 0; i < cartItems.length; i++) {
                if (typeof campaignAdjustQuantities[i] === 'number') {
                    cartItems[i].quantity = campaignAdjustQuantities[i];
                }
            }
            promo = campaign.promo;
        } else {
            promo = campaign.promo.map(p => ({ id: p.id, quantity: 0 }));
        }

        return { cartItems: cartItems, promo: promo };
    },

    updateCartView: function () {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-promo' });
    },
    clearCart: function () {
        fetch('/cart/clear.js', {
            method: "POST",
            headers: { "Content-Type": "application/json" }
        })
            .then(response => response.json())
            .then(() => {
                window.location.href = '/cart/';
            })
            .catch(error => console.error("Errore nella pulizia del carrello:", error));
    }
};